import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SmtpService{
    constructor(private http:HttpClient){}
    testSmtpConnection(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/testSmtpConnection";
        return this.http.post<any>(url, body, { headers });
    }

    saveSmtpConnection(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/saveSmtpConnection";
        return this.http.post<any>(url, body, { headers });
    }
    getSmtpDetailsByUserId(body: any){
        const headers = {
            'Content-Type': 'application/json'
        };
        let url = environment.auth_url+"/api/getSmtpDetailsByUserId";
        return this.http.post<any>(url, body, { headers });
    }
}